import { bool, instanceOf } from 'prop-types'

import IconMultiple from '../../icon/icon-multiple.js'
import IconVideoFile from '../../icon/icon-video-file.js'
import Post from '../../../../models/Post.js'
import Settings from '../../../../models/settings.js'

export default function PostTypeIndicator({ post, autoplayEnabled = false, settings }) {
  if (!post.hasMedia || !settings.showPostIndicator) {
    return null
  }

  if (post.isCarouselPost || (post.hasVideo && !autoplayEnabled) || post.isYoutubePost) {
    const icon = post.isCarouselPost ? <IconMultiple /> : <IconVideoFile />
    return <div className="post-type-indicator">{icon}</div>
  }
  return null
}

PostTypeIndicator.propTypes = {
  autoplayEnabled: bool,
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
